import React, { useState } from 'react';
import { XIcon, ChevronRightIcon, AlertCircleIcon, CalendarIcon, TrophyIcon } from 'lucide-react';
interface CreateChallengeModalProps {
  isOpen: boolean;
  onClose: () => void;
}
const CreateChallengeModal: React.FC<CreateChallengeModalProps> = ({
  isOpen,
  onClose
}) => {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    emoji: '🎯',
    duration: '7',
    action: ''
  });
  const emojiOptions = ['🎯', '🚲', '🚶', '♻️', '🥗', '💡', '🌱', '🚙', '🏃', '🌍', '💚', '🌿', '🔋', '💧', '🌤️', '🍃'];
  const durationOptions = [{
    value: '1',
    label: '1 giorno'
  }, {
    value: '3',
    label: '3 giorni'
  }, {
    value: '7',
    label: '7 giorni'
  }, {
    value: '14',
    label: '14 giorni'
  }, {
    value: '30',
    label: '30 giorni'
  }];
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = () => {
    console.log('Challenge data:', formData);
    alert('Challenge inviata! Sarà revisionata da un admin Greenback. Riceverai una notifica quando sarà approvata e visibile alla community.');
    handleClose();
  };
  const handleClose = () => {
    onClose();
    setTimeout(() => {
      setStep(1);
      setFormData({
        title: '',
        description: '',
        emoji: '🎯',
        duration: '7',
        action: ''
      });
    }, 300);
  };
  const canProceedStep1 = formData.title && formData.description;
  const canProceedStep2 = formData.action;
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 overflow-y-auto" data-id="element-203">
      <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" data-id="element-204">
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" onClick={handleClose} data-id="element-205"></div>

        <div className="inline-block align-bottom bg-white rounded-xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full" data-id="element-206">
          <div className="bg-white px-6 pt-6 pb-4" data-id="element-207">
            {/* Header */}
            <div className="flex justify-between items-center mb-6" data-id="element-208">
              <div data-id="element-209">
                <h3 className="text-xl font-semibold text-gray-900" data-id="element-210">
                  Crea una Challenge
                </h3>
                <p className="text-sm text-gray-500 mt-1 font-normal" data-id="element-211">
                  Passo {step} di 3
                </p>
              </div>
              <button onClick={handleClose} className="text-gray-400 hover:text-gray-500 transition-colors" data-id="element-212">
                <XIcon size={24} strokeWidth={1.5} data-id="element-213" />
              </button>
            </div>

            {/* Progress Bar */}
            <div className="mb-8" data-id="element-214">
              <div className="flex space-x-2" data-id="element-215">
                <div className={`flex-1 h-1 rounded-full ${step >= 1 ? 'bg-green-600' : 'bg-gray-200'}`} data-id="element-216"></div>
                <div className={`flex-1 h-1 rounded-full ${step >= 2 ? 'bg-green-600' : 'bg-gray-200'}`} data-id="element-217"></div>
                <div className={`flex-1 h-1 rounded-full ${step >= 3 ? 'bg-green-600' : 'bg-gray-200'}`} data-id="element-218"></div>
              </div>
            </div>

            {/* Step Content */}
            <div className="space-y-5" data-id="element-219">
              {step === 1 && <>
                  <div data-id="element-220">
                    <label htmlFor="title" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-221">
                      Titolo della challenge *
                    </label>
                    <input type="text" id="title" name="title" value={formData.title} onChange={handleInputChange} className="block w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-green-500 focus:border-green-500 text-sm font-normal" placeholder="Es: Settimana Zero Plastica" data-id="element-222" />
                  </div>

                  <div data-id="element-223">
                    <label htmlFor="description" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-224">
                      Descrizione breve *
                    </label>
                    <textarea id="description" name="description" value={formData.description} onChange={handleInputChange} rows={3} maxLength={150} className="block w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-green-500 focus:border-green-500 text-sm font-normal" placeholder="Descrivi la sfida in modo chiaro e motivante (max 150 caratteri)" data-id="element-225"></textarea>
                    <p className="text-xs text-gray-500 mt-1 font-normal" data-id="element-226">
                      {formData.description.length}/150 caratteri
                    </p>
                  </div>

                  <div data-id="element-227">
                    <label className="block text-sm font-medium text-gray-700 mb-3" data-id="element-228">
                      Emoji rappresentativa *
                    </label>
                    <div className="grid grid-cols-8 gap-2" data-id="element-229">
                      {emojiOptions.map(emoji => <button key={emoji} type="button" onClick={() => setFormData(prev => ({
                    ...prev,
                    emoji
                  }))} className={`text-2xl p-2 rounded-lg border-2 transition-all hover:scale-110 ${formData.emoji === emoji ? 'border-green-600 bg-green-50' : 'border-gray-200 hover:border-gray-300'}`} data-id="element-230">
                          {emoji}
                        </button>)}
                    </div>
                  </div>
                </>}

              {step === 2 && <>
                  <div data-id="element-231">
                    <label htmlFor="duration" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-232">
                      Durata della challenge *
                    </label>
                    <select id="duration" name="duration" value={formData.duration} onChange={handleInputChange} className="block w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-green-500 focus:border-green-500 text-sm font-normal" data-id="element-233">
                      {durationOptions.map(option => <option key={option.value} value={option.value} data-id="element-234">
                          {option.label}
                        </option>)}
                    </select>
                  </div>

                  <div data-id="element-235">
                    <label htmlFor="action" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-236">
                      Azione connessa *
                    </label>
                    <input type="text" id="action" name="action" value={formData.action} onChange={handleInputChange} className="block w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-green-500 focus:border-green-500 text-sm font-normal" placeholder="Es: Usa borraccia invece di bottiglie di plastica" data-id="element-237" />
                    <p className="text-xs text-gray-500 mt-1 font-normal" data-id="element-238">
                      Specifica l'azione concreta che i partecipanti dovranno
                      compiere
                    </p>
                  </div>

                  <div className="bg-blue-50 border border-blue-200 rounded-lg p-4" data-id="element-239">
                    <div className="flex items-start" data-id="element-240">
                      <TrophyIcon className="text-blue-600 mt-0.5 mr-3 flex-shrink-0" size={20} strokeWidth={1.5} data-id="element-241" />
                      <div className="text-sm text-blue-800 font-normal" data-id="element-242">
                        <p className="font-medium mb-1" data-id="element-243">Ricompensa Star</p>
                        <p className="leading-relaxed" data-id="element-244">
                          La ricompensa in Star sarà assegnata automaticamente
                          in base alla durata e alla difficoltà della challenge.
                        </p>
                      </div>
                    </div>
                  </div>
                </>}

              {step === 3 && <>
                  <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4" data-id="element-245">
                    <div className="flex items-start" data-id="element-246">
                      <AlertCircleIcon className="text-yellow-600 mt-0.5 mr-3 flex-shrink-0" size={20} strokeWidth={1.5} data-id="element-247" />
                      <div className="text-sm text-yellow-800 font-normal" data-id="element-248">
                        <p className="font-medium mb-1" data-id="element-249">
                          Approvazione richiesta
                        </p>
                        <p className="leading-relaxed" data-id="element-250">
                          La tua challenge sarà inviata per l'approvazione. Non
                          sarà visibile alla community fino a quando un
                          amministratore Greenback non l'avrà revisionata e
                          approvata. Riceverai una notifica via email quando
                          sarà attiva.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="bg-gray-50 rounded-lg p-4 space-y-4" data-id="element-251">
                    <h4 className="font-medium text-gray-900" data-id="element-252">Riepilogo</h4>

                    <div className="flex items-center gap-3" data-id="element-253">
                      <div className="text-4xl" data-id="element-254">{formData.emoji}</div>
                      <div className="flex-1" data-id="element-255">
                        <p className="text-xs text-gray-500 mb-1" data-id="element-256">Titolo</p>
                        <p className="text-sm text-gray-900 font-medium" data-id="element-257">
                          {formData.title}
                        </p>
                      </div>
                    </div>

                    <div data-id="element-258">
                      <p className="text-xs text-gray-500 mb-1" data-id="element-259">Descrizione</p>
                      <p className="text-sm text-gray-900 font-normal" data-id="element-260">
                        {formData.description}
                      </p>
                    </div>

                    <div className="grid grid-cols-2 gap-3" data-id="element-261">
                      <div data-id="element-262">
                        <p className="text-xs text-gray-500 mb-1" data-id="element-263">Durata</p>
                        <p className="text-sm text-gray-900 font-normal" data-id="element-264">
                          {durationOptions.find(d => d.value === formData.duration)?.label}
                        </p>
                      </div>
                      <div data-id="element-265">
                        <p className="text-xs text-gray-500 mb-1" data-id="element-266">
                          Ricompensa stimata
                        </p>
                        <p className="text-sm text-yellow-600 font-medium flex items-center" data-id="element-267">
                          <span className="text-lg mr-1" data-id="element-268">⭐</span>
                          {parseInt(formData.duration) * 30} Star
                        </p>
                      </div>
                    </div>

                    <div data-id="element-269">
                      <p className="text-xs text-gray-500 mb-1" data-id="element-270">
                        Azione connessa
                      </p>
                      <p className="text-sm text-gray-900 font-normal" data-id="element-271">
                        {formData.action}
                      </p>
                    </div>
                  </div>
                </>}
            </div>
          </div>

          {/* Footer */}
          <div className="bg-gray-50 px-6 py-4 sm:flex sm:flex-row-reverse gap-3" data-id="element-272">
            {step < 3 ? <>
                <button type="button" onClick={() => setStep(step + 1)} disabled={step === 1 && !canProceedStep1 || step === 2 && !canProceedStep2} className="w-full inline-flex justify-center items-center rounded-lg border border-transparent shadow-sm px-4 py-2.5 bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:ml-3 sm:w-auto sm:text-sm disabled:opacity-50 disabled:cursor-not-allowed transition-colors" data-id="element-273">
                  Avanti
                  <ChevronRightIcon size={16} className="ml-1" strokeWidth={2} data-id="element-274" />
                </button>
                {step > 1 && <button type="button" onClick={() => setStep(step - 1)} className="mt-3 w-full inline-flex justify-center rounded-lg border border-gray-300 shadow-sm px-4 py-2.5 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:mt-0 sm:w-auto sm:text-sm transition-colors" data-id="element-275">
                    Indietro
                  </button>}
              </> : <>
                <button type="button" onClick={handleSubmit} className="w-full inline-flex justify-center rounded-lg border border-transparent shadow-sm px-4 py-2.5 bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:ml-3 sm:w-auto sm:text-sm transition-colors" data-id="element-276">
                  Invia Challenge
                </button>
                <button type="button" onClick={() => setStep(step - 1)} className="mt-3 w-full inline-flex justify-center rounded-lg border border-gray-300 shadow-sm px-4 py-2.5 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:mt-0 sm:w-auto sm:text-sm transition-colors" data-id="element-277">
                  Indietro
                </button>
              </>}
          </div>
        </div>
      </div>
    </div>;
};
export default CreateChallengeModal;